import { render, staticRenderFns } from "./ChamadoContainer.vue?vue&type=template&id=25507f5e&scoped=true"
import script from "./ChamadoContainer.vue?vue&type=script&lang=js"
export * from "./ChamadoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25507f5e",
  null
  
)

export default component.exports